import { List, Record } from 'immutable';
import FilterDefinitionTypeConstants from '~/constants/filter-definition-type-constants';
import NameRecord from '~/ducks/machine-filter-v2/data/NameRecord';
import type { SharedFilterFields } from '../../types/filter-value-types';

const keys: Fields = {
  filterName: new NameRecord(),
  assetIds: List<string>(),
  type: FilterDefinitionTypeConstants.SELECTED_MACHINES,
};

export interface Fields extends SharedFilterFields {
  assetIds: List<string>;
  type: FilterDefinitionTypeConstants.SELECTED_MACHINES;
}

export default class SelectedMachinesFilterRecord extends Record<Fields>(keys) {
  constructor(values?) {
    super(values);
    const newValues: Partial<Fields> = {
      filterName: values?.filterDefinition?.getNameRecord(),
    };

    return this.merge(newValues);
  }

  getFilterKey() {
    return null;
  }

  getType() {
    return this.type;
  }

  getName() {
    return this.filterName.getName();
  }

  getTranslationKey(): string {
    return this.filterName.getTranslationKey() || '';
  }

  getValues(): List<string> {
    return this.assetIds;
  }

  add(assetId: string) {
    return this.update('assetIds', (assetIds) => assetIds.push(assetId));
  }

  removeValue() {
    return null;
  }
}
